import { gql } from '@apollo/client';

export default gql`
  query getCustomerDetails($membershipNumber: String, $email: String, $bookingReference: String) {
    getCustomerDetails(membershipNumber: $membershipNumber, email: $email, bookingReference: $bookingReference) {
      name
      firstName
      lastName
      emailAddress
      phoneNumber
      address {
        street
        city
        postalCode
        countryCode
      }
      profile {
        customerId
        dateOfBirth
        loyalty {
          membershipNumber
          rewardPoints
          availableLoyaltyDiscounts {
            amount
            currency
            points
          }
        }
      }
    }
  }
`;
